module.exports = require("@wildboar/x500/src/lib/modules/OperationalBindingManagement/EstablishOperationalBindingResult.ta");